export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_10-bf03ea25ae6ab991c5db80d753724eeb.jpg";